<template>
  <q-page>
    <Banner />
    <Plan />
    <ItemsIntro />
    <!-- <InspectionItems />
    <Contact /> -->
    <Other />
  </q-page>
</template>
<style lang="scss" scoped>
</style>
<script>
import Banner from '@/components/home-inspection-plan/Banner.vue'
import Plan from '@/components/home-inspection-plan/Plan.vue'
import ItemsIntro from '../components/home-inspection-plan/ItemsIntro.vue'
// import InspectionItems from '@/components/home-inspection-plan/InspectionItems.vue'
// import Contact from '@/components/home-inspection-plan/Contact.vue'
import Other from '@/components/home-inspection-plan/Other.vue'
import { useMeta } from 'vue-meta'
export default {
  name: 'Spend',
  components: {
    Banner,
    Plan,
    ItemsIntro,
    Other
    // InspectionItems,
    // Contact,
  },
  data () {
    return {
    }
  },
  methods: {},
  created () {
    useMeta({ title: '驗屋方案' })
  }
}
</script>
